import React from "react";

import "./rows/index.sass";

export const ProfileRow = ({
  label,
  value,
  actions,
  notice,
  error,
  className = "",
}) => {
  const hasNotice = Boolean(notice);

  return (
    <div
      className={`profile-row ${
        hasNotice
          ? "profile-row--notice"
          : ""
      } ${className}`}
    >
      <div className="profile-row__label">
        {label}
      </div>

      {hasNotice ? (
        <div className="profile-row__notice">
          {notice}
        </div>
      ) : (
        <>
          <div
            className={`profile-row__value ${
              error ? "profile-row__value--with-error" : ""
            }`}
          >
            {value}

            {error && (
              <p className="profile-row__error">
                {error}
              </p>
            )}
          </div>

          <div className="profile-action">
            {actions}
          </div>
        </>
      )}
    </div>
  );
};
